import mapFunction from './mapResources';

export default mapFunction('master_employees', {
    isFetching: false,
    items: []
});